import _Calendar from "./Calendar";
import { withInstall } from "./utils";
const Calendar = withInstall(_Calendar);
var stdin_default = Calendar;
import { calendarProps } from "./Calendar";
export {
  Calendar,
  calendarProps,
  stdin_default as default
};
